import Vue from 'vue'
import on from 'dom-event'
import { contains } from 'lib/util'
import countdown from '@chenfengyuan/vue-countdown'

export default function (el) {
  const storeTime = Number(el.getAttribute('data-store-time'))
  const countdownTime = Number(el.getAttribute('data-countdown') * 1000)
  return new Vue({
    el,
    data: {
      storeTime,
      countdownTime,
      hasEnded: false,
      height: 125
    },
    mounted () {
      this.overlayMode()
      on(window, 'resize', () => {
        this.overlayMode()
      })
    },
    components: {
      'vue-countdown': countdown
    },
    methods: {
      overlayMode () {
        this.height = this.$el.offsetHeight / 2
        if (contains(this.$el, 'overlay-mode')) {
          this.$el.style.marginTop = '-' + this.height + 'px'
        }
      },
      onEnd () {
        this.hasEnded = true
      },
      timeNow () {
        const d = new Date()
        return d.valueOf()
      },
      transform (props) {
        Object.entries(props).forEach(([key, value]) => {
          if (['days', 'hours', 'minutes', 'seconds'].includes(key)) {
            const digits = value < 10 ? `0${value}` : value
            props[key] = String(digits).split('')
          } else {
            delete props[key]
          }
        })
        return props
      }
    }
  })
}
